import axios from "../../config/axios";
const socialLogin = {    
  facebookLogin: (params) =>
      axios
        .post(`/reviewmanagement/socialLogin/facebook`,params)
        .then((resp) =>  resp.data)
        .catch((err) => console.log(err)),
};
export default socialLogin;
